import catalogJson from '@/data/textureCatalog.json';
import type { TextureCatalogEntry, TextureId } from '@/types/domain';

const ENTRIES = catalogJson as TextureCatalogEntry[];
const BY_ID = new Map<TextureId, TextureCatalogEntry>(ENTRIES.map((e) => [e.id, e]));

export class TextureCatalog {
  all(): TextureCatalogEntry[] {
    return ENTRIES;
  }
  get(id: TextureId): TextureCatalogEntry | undefined {
    return BY_ID.get(id);
  }
  has(id: TextureId): boolean {
    return BY_ID.has(id);
  }
  /** Resolve a texture id to a served image path (relative to /textures). */
  pathFor(id: TextureId): string | undefined {
    return BY_ID.get(id)?.path;
  }
  /** Resolve a texture id to the web URL used by <img>. */
  urlFor(id: TextureId): string | undefined {
    const p = BY_ID.get(id)?.path;
    return p ? `${import.meta.env.BASE_URL}textures/${p}` : undefined;
  }
  search(query: string, limit = 50): TextureCatalogEntry[] {
    const q = query.trim().toLowerCase();
    if (!q) return ENTRIES.slice(0, limit);
    return ENTRIES.filter(
      (e) => e.id.toLowerCase().includes(q) || e.name.toLowerCase().includes(q) || e.tags.some((t) => t.includes(q)),
    ).slice(0, limit);
  }
  count(): number {
    return ENTRIES.length;
  }
}

export const textureCatalog = new TextureCatalog();
